import ErrorTypes from '../constants/ErrorTypes';
export function errorMessageWithFallback(msgType) {
  return Object.values(ErrorTypes).includes(msgType) ? msgType : ErrorTypes.FALLBACK;
}